var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{attrs:{"normal":"","center":"","dark":_vm.dark,"dense":_vm.dense,"disabled":_vm.disabled,"color":_vm.iconColor,"size":"20"},domProps:{"innerHTML":_vm._s(_vm.icon)}})}
var staticRenderFns = []

export { render, staticRenderFns }